import { CustomButton } from 'components/shared/CustomButton';
import { CustomNumberOnlyBox } from 'components/shared/CustomNumberOnlyBox';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import { CustomToaster } from 'components/shared/CustomToaster';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import { IReportDelayModel } from 'models/ReportDelay.Model';
import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Alert, Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import CommonService from 'services/CommonService';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    showOnlyIcon?: boolean,
    data?: IGetOrderSummaryModel,
    orderId?: any;
}

function Delay({ showOnlyIcon, data, orderId, ...rest }: inputProps, ref) {
    const { id } = useParams<any>();
    const [showModal, setShowModal] = useState(false);
    const [hoursData, setHoursData] = useState<number>(0);
    const [commentsData, setCommentsData] = useState<string>("");
    const [isButton, SetisButton] = useState(false);
    const [toast, setToast] = useState(false);
    const [warn, setWarn] = useState(false);
    const [delayButtonClicked, setDelayButtonClicked] = useState(false);


    const ReportDelayOrderData = () => {
        if (hoursData == 0 || commentsData ==""){
            return setWarn(true);
        }
        setDelayButtonClicked(true);
        const Data = {
            OrderId: data?.Appointment.OrderId,
            DelayHours: hoursData,
            DelayComments: commentsData,
        };
        CommonService.post("Sell", "ReportDelayOrder", Data).then(res => {
            if (res.status === 200) {
                setCommentsData(res.data.Items);
                setShowModal(false);
                window.location.reload();
                setToast(true);
            }
        }).catch(e => {
            
            console.log(e)
        })
        SetisButton(true);
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg="12" xs="12" className='text-end'>
                    {data?.AssigneeDetails !== null ?
                        <CustomButton onClick={() => setShowModal(true)} color="warning" type={'button'} btnClassName={'btn-warning'} iconClasssName={undefined} name={'Delay the Order'} /> : null
                    }
                </Col>
                <Modal centered backdrop isOpen={showModal} animated={true} swipeToClose={true} className="modal-assignee"
                    onDidDismiss={() => setShowModal(false)}>
                    <ModalBody>
                        <Row className='mb-1'>
                            <Col xl={10} lg={10} md={10} sm={10} xs={10} >
                                <div className=''>
                                    <i className='fas fa-clock text-dofy me-2 font-size-15 '></i>
                                    <span className='font-size-16 fw-semibold text-dofy'>Set Order Delay with Reason</span>
                                </div>
                            </Col>
                            <Col className='text-end' xl={2} lg={2} md={2} sm={2} xs={2}>
                                <i className='bx bx-x font-size-18 cursor-pointer' onClick={() => setShowModal(false)}></i>
                            </Col>
                        </Row>
                        {warn ?
                            <div className='my-2'>
                                <Alert
                                    color="warning"
                                    className="fade show"
                                    role="alert"
                                >
                                    <i className="mdi mdi-alert-outline me-2"></i>
                                    Kindly Check the Delay fields
                                </Alert>
                            </div> : null}
                        <div>
                            <Row>
                                <Col lg="12" xl="12" md="12" xs="12">
                                    <CustomNumberOnlyBox label={'Delay (in hrs)'} isMandatory={true}  id={'hoursData'} value={hoursData} error={undefined} onChange={(e: any) => { setHoursData(e.target.value); setWarn(false) }} />
                                    <CustomTextArea isMandatory={true} label={'Delay Reason'} id={'commentsData'} value={commentsData} error={undefined} onChange={(e: any) => { setCommentsData(e.target.value); setWarn(false) }} />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xl="12" sizeSm="11" md="12" xs="12" lg="12" className="d-flex justify-content-end">
                                    <CustomButton type={'reset'} btnClassName={'btn-soft-secondary me-2'} iconClasssName={'bx bx-x font-size-18'} name={undefined} onClick={() => { setShowModal(false); setWarn(false) }} />
                                    <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={''} name={'Set Delay'} disabled ={delayButtonClicked} onClick={() => ReportDelayOrderData()} />
                                </Col>
                            </Row>

                        </div>
                    </ModalBody>
                </Modal>
                {toast ?
                    <CustomToaster message={'Your delay response have been saved.'} color={'text-success'} toast={toast} setToast={setToast} /> : null}
            </Row>
        </React.Fragment>
    )
}

export default Delay
